import * as saleTotalConstant from './constants'

const initialState = {
  list: [],
  listNV: [],
  listKH: [],
  listKHO: [],
  listEXP: [],
  item: {},
  type: saleTotalConstant.SALE_TOTAL_REPORT_LIST_INITING,
  listRequesting: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  listNhomKh: []
}

const reducer = function saleTotalReducer(state = initialState, action) {
  switch (action.type) {
    case saleTotalConstant.SALE_TOTAL_REPORT_NVKD_REQUESTING:
      return {
        type: action.type,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_NVKD_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNV: action.data,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_NVKD_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case saleTotalConstant.SALE_TOTAL_REPORT_KH_REQUESTING:
      return {
        type: action.type,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KH_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKH: action.data,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KH_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_REQUESTING:
      return {
        type: action.type
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKHO: action.data
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KHOXUAT_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    case saleTotalConstant.SALE_TOTAL_REPORT_LIST_REQUESTING:
      return {
        list: [],
        item: {},
        type: action.type,
        listRequesting: true,
        requesting: false,
        successful: false,
        messages: [{
          body: 'Đang tải dữ liệu...!',
          time: new Date(),
        }],
        errors: [],
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_LIST_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: action.data ? action.data.records : [],
        item: action.data || {},
        listRequesting: false,
        requesting: false,
        successful: true,
        messages: [],
        errors: [],
      }

    case saleTotalConstant.SALE_TOTAL_SALE_TOTAL_REPORT_LIST_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        list: [],
        item: {},
        listRequesting: false,
        requesting: false,
        successful: false,
        messages: [],
        errors: [{
          body: action.error.toString(),
          time: new Date(),
        }],
      }
    case saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_REQUESTING:
      return {
        ...state,
        type: action.type,
        listRequesting: true,
        formData: action.payload,
        callback: action.callback,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
        listEXP: action.data,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_EXPORT_XLS_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listRequesting: false,
      }
    case saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_REQUESTING:
      return {
        type: action.type,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listNhomKh: action.data.records || [],
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_NHOMKH_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_REQUESTING:
      return {
        type: action.type,
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_SUCCESS:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
        listKH: action.data || [],
      }

    case saleTotalConstant.SALE_TOTAL_REPORT_KH_BY_NHOM_ERROR:
      return {
        ...state, // ensure that we don't erase fetched ones
        type: action.type,
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/Reports/SaleTotalReport/reducer.js